import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowRightThinIconSvg from './icon-arrow-right-thin.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowRightThinIconSvg {...validProps} />;
}
SvgComponent.iconName = 'arrowRightThinIcon';

/**
 * @deprecated This is a legacy icon
 */
export const ArrowRightThinIcon = svgIconWrapper(SvgComponent);
